import ky from 'ky';

import { accessTokenStore } from '@state/authInfo';
import { ENV } from '@utils/env';
import { tryCatch } from '@utils/tryCatch';

const apiCreate = (prefixUrl) =>
  ky.create({
    prefixUrl,
    retry: {
      limit: 0,
    },
    timeout: 20000,
    credentials: 'include',
    hooks: {
      // Set auth header from local storage every request
      beforeRequest: [
        async (request) => {
          const [error, accessToken] = await tryCatch(
            accessTokenStore.getToken()
          );

          if (error?.message.includes('refresh token')) {
            await accessTokenStore.logout();
          }

          if (accessToken == null) {
            return new Response(JSON.stringify({ error: 'no_token' }), {
              status: 401,
            });
          }

          // workaround for request cloning issue in chromium for tests
          // https://github.com/microsoft/playwright/issues/6479
          if (window.localStorage.getItem('DISABLE_KY_CLONE') === 'true') {
            request.clone = () => request;
          }

          request.headers.set('Authorization', `Bearer ${accessToken}`);
          return request;
        },
      ],
      // Handle auth errors on 401/403
      afterResponse: [
        async (request, _options, response) => {
          const status = response.status;
          if (status === 401 || status === 403) {
            const body = await response.json();

            if (
              body.error &&
              (body.error === 'mfa_required' || body.error === 'no_token')
            ) {
              // Auth is totally invalid; trigger logout
              await accessTokenStore.logout();
            }

            return response;
          }
        },
      ],
    },
  });

/**
 * Instance of Ky set up with Evervault API Relay Domain as the prefix
 */
export const api = apiCreate(ENV.apiUrls.internal);
/**
 * Instance of Ky set up with Evervault Direct API Domain as the prefix
 */
export const directApi = apiCreate(ENV.apiUrls.internalDirect);
